import type { Language } from '@bravo/shared';
import { create } from 'zustand';

export type ThemeChoice = 'light' | 'dark' | 'system';

const THEME_KEY = 'bravo.admin.theme';
const LANG_KEY = 'bravo.admin.lang';

function readTheme(): ThemeChoice {
  const saved = localStorage.getItem(THEME_KEY);
  return saved === 'light' || saved === 'dark' || saved === 'system' ? saved : 'system';
}

function readLanguage(): Language {
  return localStorage.getItem(LANG_KEY) === 'am' ? 'am' : 'en';
}

export function applyTheme(theme: ThemeChoice): void {
  const dark =
    theme === 'dark' ||
    (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
}

interface PrefsState {
  language: Language;
  theme: ThemeChoice;
  setLanguage: (language: Language) => void;
  setTheme: (theme: ThemeChoice) => void;
}

export const usePrefsStore = create<PrefsState>((set) => ({
  language: readLanguage(),
  theme: readTheme(),
  setLanguage: (language) => {
    localStorage.setItem(LANG_KEY, language);
    document.documentElement.lang = language;
    set({ language });
  },
  setTheme: (theme) => {
    localStorage.setItem(THEME_KEY, theme);
    applyTheme(theme);
    set({ theme });
  },
}));

applyTheme(readTheme());
document.documentElement.lang = readLanguage();
